import { getIntroductionRoutes, IntroductionRoutes } from '../../routes/introduction-routes';
import { getDemographicRoutes } from '../../routes/demographic-routes';
import { getAssessmentRoutes, TaskRoutes, OutcomeRoutes } from '../../routes/assessment-routes';
import { assessmentStatus } from '../../Constants';
import moment from 'moment';

import {
    REQUEST_START,
    REQUEST_SAVED,
    REQUEST_ERROR,
    REQUEST_END,
    GET_DATA,
    SET_DEMOGRAPHICS_RESPONSE,
    SET_DATA_RESPONSE,
    SET_TERMS,
    SET_TERMS_DECLINE,
    SET_CONSENT,
    SET_CONSENT_DECLINE,
    SET_ASSESSMENT_STATUS,
    SET_TASK_RESPONSE,
    SET_TERMINATION,
    SET_SKIP_REMAINING_TASKS,
    RESET_SKIPPED_TASKS,
    SET_OUTCOME_RESPONSE,
    SET_SCREEN_DURATION,
    SET_TASK_DURATION,
    SET_OUTCOME_DURATION,
    CLEAR_RESPONSE,
    SET_TASK_PLAYED,
    SET_CURRENT_PERCENTAGE,
    SET_TOTAL_PERCENTAGE,
    getTasks,
    getTaskTypeIdById,
    TaskSegment,
    SET_DEMOGRAPHICS_FOR_VERSION,
} from '../actions/data-action';
import { getTaskDuration } from './utility';

var dataInitialState = {
  terms: null,
  termsDecline: null,
  consent: null,
  consentDecline: null,
  terminated: false,
  terminationReason: null,
  sessionID: null,
  outcomes: [],
  screens: []
};

const requestInitialState = {
    isProcessing: false,
    saved: false,
    hasError: false,
    error: ''
}

export const data = (data = dataInitialState, action) => {
    switch (action.type) {
        // case SET_DEMOGRAPHICS_FOR_VERSION:
        //   var dDemographics = {};
        //       dDemographics = {
        //             Age: '',
        //             Gender: '',
        //             PFSex: '',
        //             PFSexOtherSP: '',
        //             PFGender: '',
        //             PFGenderOtherSP: '',
        //             PFAge: '',
        //             PFDOB: '',
        //             PFCountry: '',
        //             PFState: '',
        //             PFHispanic: '',
        //             PFHispanicOtherSP: '',
        //             PFRace: '',
        //             PFRaceOtherSP: '',
        //             PFPEL: '',
        //             PFOtherParentPEL: '',
        //             PFProvince: '',
        //             PFAboriginal: '',
        //             PFDiagnosed: '',
        //             PFServices: '',
        //             PFServicesTypeLD: '',
        //             PFServicesTypeEBP: '',
        //             PFServicesTypeID: '',
        //             PFServicesTypeOther: '',
        //             PFServicesTypeOtherSP: '',
        //             PFSettingChildcareCentre: '',
        //             PFSettingHome: '',
        //             PFSettingPreschool: '',
        //             PFSettingK: '',
        //             PFSettingGr1: '',
        //             PFSettingGr2: '',
        //             PFSettingOther: '',
        //             PFSettingOtherSP: '',
        //             PFSchoolType: '',
        //             PFSchoolTypeOtherSP: '',
        //             PFRelation: '',
        //             PFRelationOtherSP: '',
        //             PFLanguage: '',
        //             PFLanguageType: '',
        //             PFNonEngSP: '',
        //             PFLanguageEC: '',
        //             PFSentencesEC: '',
        //             PFUnderstandLanguageEC: '',
        //             PFSentences: '',
        //             PFUnderstandLanguage: '',
        //             rater : {
        //                 Voluntary: '',
        //                 Compensation: '',
        //                 Confidential: '',
        //                 PFID: '',
        //                 PFSite: '',
        //                 PFRaterGender: '',
        //                 PFRaterGenderOtherSP: '',
        //                 PFRaterAge: '',
        //                 PFRaterCountry: '',
        //                 PFRaterRace: '',
        //                 PFRaterRaceOtherSP: '',
        //                 PFRaterHispanic: '',
        //                 PFRaterHispanicOtherSP: '',
        //                 PFRaterAboriginal: '',
        //                 PFRaterReadEnglish: ''
        //             },
        //             postAdmin : {
        //                 PFConcerns: '',
        //                 PFStrengths: '',
        //                 PFRead: '',
        //                 PFReadWho: '',
        //                 PFReadWhy: '',
        //                 PFComplete: '',
        //                 PFCompleteWho: '',
        //                 PFCompleteWhy: ''
        //             }
            
        //           };
        //     return Object.assign({}, data, {demographics: dDemographics}) ;
        case GET_DATA:

            // if (action.data.screens === false || action.data.screens.length === 0) {
            //     //debugger;
            //     //action.data.screens = getScreens(action.data);
            // }

            return Object.assign({}, data, action.data);
        case SET_SCREEN_DURATION:
            const aScreens = Array.from(data.screens);

            aScreens.map((item, index) => {
                if (item.url === action.url) {
                    let duration = item.duration;

                    if (isNaN(duration)) {
                        duration = 0;
                    }

                    item.duration = duration + ((action.end - action.start) / 1000)
                }

                return item;
            })

            return Object.assign({}, data, { screens: aScreens });
        case SET_TERMS:
            return Object.assign({}, data, { terms: action.value });
        case SET_TERMS_DECLINE:
            return Object.assign({}, data, { termsDecline: action.value });
        case SET_CONSENT:
            return Object.assign({}, data, { consent: action.value });
        case SET_CONSENT_DECLINE:
            return Object.assign({}, data, { consentDecline: action.value });
        case SET_ASSESSMENT_STATUS:
            if (action.value === assessmentStatus.Complete || action.value === assessmentStatus.Fail ) {
                var date = moment.utc();
                return Object.assign({}, data, { status: action.value, dateTimeSubmitted: date.format("YYYY-MM-DD HH:mm:ss")});
            }else {
                return Object.assign({}, data, { status: action.value, dateTimeSubmitted: null });
            }
        case SET_DEMOGRAPHICS_RESPONSE:
            var demographics = { ...data.demographics };

            if (typeof(action.name) === "object") {
              demographics = {...demographics, ...action.name};
            } else {
              if (action.child) {
                demographics[action.child][action.name] = action.value;
              } else {
                // if (!demographics[action.name])demographics[action.name] = [];
                // demographics[action.name].push(action.value);
                demographics[action.name] = action.value;
              }
            }

            return Object.assign({}, data, { demographics: demographics });
        case SET_DATA_RESPONSE:
            const dataObj = {...data };
            dataObj[action.name] = action.value

            return Object.assign({}, data, dataObj);
        case SET_OUTCOME_RESPONSE:
            const outcomes = Array.from(data.outcomes);
            outcomes.map((item, index) => {
                if (item.id === action.id) {
                    const response = [];
                    response[0] = action.response;
                    item.response = response;
                }

                return item;
            })

            return Object.assign({}, data, { outcomes: outcomes });
        case SET_OUTCOME_DURATION:
            const outcomesDuration = Array.from(data.outcomes);
            outcomesDuration.map((item, index) => {
                if (item.id === action.outcome.id) {
                    let duration = item.duration;

                    if (isNaN(duration)) {
                        duration = 0;
                    }

                    item.duration = duration + ((action.end - action.start) / 1000) % 60
                }

                return item;
            })

            return Object.assign({}, data, { outcomes: outcomesDuration });

        case SET_TASK_RESPONSE:
            let responseIndex = action.index;

            if (isNaN(responseIndex)) {
                responseIndex = 0;
            }
            const tasksResponse = Array.from(data.tasks);

            getTasks(tasksResponse, action.taskType, action.subTaskType).map((item, index) => {
                if (item.id === action.task.id) {
                    if (item.response) {
                        const response = item.response;
                        response[responseIndex] = action.response;
                        item.response = response;
                    } else {
                        const response = [];
                        response[responseIndex] = action.response;
                        item.response = response;
                    }
                }

                return item;
            })

            return Object.assign({}, data, { tasks: tasksResponse });
        case SET_SKIP_REMAINING_TASKS:
            const tasksSkip = Array.from(data.tasks);
            let currentTaskIndex = 0;

            getTasks(tasksSkip, action.taskType, action.subTaskType).map((item, index) => {
                if (item.id === action.task.id) {
                    currentTaskIndex = index;
                }

                if (index > currentTaskIndex) {
                    item.skipped = true;
                }

                return item;
            })

            return Object.assign({}, data, { tasks: tasksSkip });

        case RESET_SKIPPED_TASKS:
            const tasksResetSkip = Array.from(data.tasks);

            getTasks(tasksResetSkip, action.taskType, action.subTaskType).map((item, index) => {
                item.skipped = false;

                return item;
            })

            return Object.assign({}, data, { tasks: tasksResetSkip });
        case CLEAR_RESPONSE:
            const tasksClear = Array.from(data.tasks);

            getTasks(tasksClear, action.taskType, action.subTaskType).map((item, index) => {
                if (item.id === action.task.id) {
                    item.response = []
                }

                return item;
            })

            return Object.assign({}, data, { tasks: tasksClear });
        case SET_TERMINATION:
            if (data.terminated === false) {
                return Object.assign({}, data, { terminated: true, terminationReason: action.terminationReason });
            } else {
                return data;
            }
        case SET_TASK_PLAYED:
            const tasksPlayed = Array.from(data.tasks);
            getTasks(tasksPlayed, action.taskType, action.subTaskType).map((item, index) => {
                if (item.id === action.task.id) {
                    const played = action.task.played;
                    if (played) {
                        return item;
                    } else {
                        item.played = true;
                        return item;
                    }
                } else {
                    return item;
                }
            });

            return Object.assign({}, data, { tasks: tasksPlayed });
        case SET_TASK_DURATION:
            const aTasks = Array.from(data.tasks);

            getTasks(aTasks, action.taskType, action.subTaskType).map((item, index) => {
                if (item.id === action.task.id) {
                    let duration = item.duration;

                    if (isNaN(duration)) {
                        duration = 0;
                    }

                    item.duration = duration + ((action.end - action.start) / 1000) % 60
                }

                return item;
            })

            return Object.assign({}, data, { tasks: aTasks });
        default:
            return data;
    }
}

export const dataRequest = (request = requestInitialState, action) => {
    switch (action.type) {
        case REQUEST_START:
            return Object.assign({}, request, { isProcessing: true, saved: false, hasError: false, error: ''});
        case REQUEST_SAVED:
            return Object.assign({}, request, { saved: true});
        case REQUEST_ERROR:
            return Object.assign({}, request, { hasError: true, error: action.error, errorCode: action.code });
        case REQUEST_END:
            return Object.assign({}, request, { isProcessing: false});
        default:
            return request;
    }
}

export const timeout = (timeout = 0, action) => {
    if (action.timeout) {
        timeout = action.timeout;
    }
    return timeout;
}

const getScreens = (data) => {
    const screens = [];
    let id = 0;

    if (data) {
        getIntroductionRoutes(data.versionID).forEach((route) => {
            if (route.monitorProgress) {
                screens.push({ id: id++, url: route.path});
            }
        })
        
        getDemographicRoutes(data.versionID).forEach((route) => {
            if (route.monitorProgress) {
                screens.push({ id: id++, url: route.path});
            }
        })

        getAssessmentRoutes(data.versionID).forEach((route) => {
            if (route.monitorProgress) {
                screens.push({ id: id++, url: route.path});
            }
        })

        if (data.tasks) {
            TaskRoutes.forEach((route) => {
                if (route.monitorProgress) {
                    ///Assessment/Tasks/:type/:segment?/:index?
                    if (route.path.includes("?")) {
                        if (data.tasks) {
                            data.tasks.forEach((task) => {
                                const currentTaskType = getTaskTypeIdById(task.id);

                                let  instructionPath = route.path
                                    .replace(':type', currentTaskType.type)
                                    .replace(':segment?', TaskSegment.INSTRUCTION)
                                    .replace('/:index?', '');

                                screens.push({ id: id++, url: instructionPath});

                                task.practice.forEach((practice, index) => {
                                    let  practicePath = route.path
                                    .replace(':type', currentTaskType.type)
                                    .replace(':segment?', TaskSegment.PRACTICE)
                                    .replace(':index?', index + 1);

                                    screens.push({ id: id++, url: practicePath});
                                })

                                let  practiceCompletePath = route.path
                                    .replace(':type', currentTaskType.type)
                                    .replace(':segment?', TaskSegment.PRACTICECOMPLETE)
                                    .replace('/:index?', '');

                                screens.push({ id: id++, url: practiceCompletePath});

                                task.tasks.forEach((practice, index) => {
                                    let  taskPath = route.path
                                    .replace(':type', currentTaskType.type)
                                    .replace(':segment?', TaskSegment.TASK)
                                    .replace(':index?', index + 1);

                                    screens.push({ id: id++, url: taskPath});
                                })

                            })

                        }
                    } else {
                        screens.push({ id: id++, url: route.path});
                    }
                }
            })
        }

        if (data.outcomes) {
            OutcomeRoutes.forEach((route) => {
                if (route.monitorProgress) {

                    //'/Assessment/Outcome/Items/:index?'
                    if (route.path.includes("?")) {
                        const outcomePages = Math.ceil(data.outcomes.length / 2);

                        for (let i = 1; i <= outcomePages; i++) {
                            let  outcomeItemPath = route.path.replace(':index?', i);

                            screens.push({ id: id++, url: outcomeItemPath});
                        }
                    } else {
                        screens.push({ id: id++, url: route.path});
                    }
                }
            })
        }
    }
    return screens;
}


export const currentPercentage = (percentage = 0, action) => {
    switch (action.type) {
        case SET_CURRENT_PERCENTAGE:
            return action.percentage;
        default:
            return percentage;
    }
}

export const totalPercentage = (percentage = 100, action) => {
    switch (action.type) {
        case SET_TOTAL_PERCENTAGE:
            return action.percentage;
        default:
            return percentage;
    }
}